import ROUTES from '@lib/constants/routes';
import { FipeVehicleTypeUrl } from '@lib/constants/routes/fipeRoutes';
import { FipeVehicleType } from '@prisma/client';


const upperCaseFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);


export const fipeBreadCrumbs = ({
  year,
  type,
  brand,
  model,
}: {
  year?: number;
  type?: FipeVehicleType | FipeVehicleTypeUrl;
  brand?: string;
  model?: string;
}) => {
  const arr = [
    { label: 'Luna', href: ROUTES.root, name: 'Luna Seguros' },
    { label: 'FIPE', href: ROUTES.fipe.home, name: 'Tabela FIPE' },
  ];

  const url: Record<FipeVehicleType | FipeVehicleTypeUrl, FipeVehicleTypeUrl> =
    {
      car: 'carros',
      motorcycle: 'motos',
      trucks: 'caminhoes',
      caminhoes: 'caminhoes',
      motos: 'motos',
      carros: 'carros',
    };

  if (type)
    arr.push({
      label: url[type].toUpperCase(),
      href: ROUTES.fipe.type({
        type,
      }),
      name: `Tabela FIPE para ${url[type].toUpperCase()}`,
    });

  if (type && brand)
    arr.push({
      label: brand,
      href: ROUTES.fipe.brand({
        type,
        brand,
      }),
      name: `Tabela FIPE ${brand}`,
    });

  if (type && brand && model)
    arr.push({
      label: model,
      href: ROUTES.fipe.model({
        type,
        brand,
        model,
      }),
      name: `Tabela FIPE ${brand} ${model}`,
    });

  if (type && brand && model && year)
    arr.push({
      label: year.toString(),
      href: ROUTES.fipe.modelYear({
        type,
        brand,
        model,
        year,
      }),
      name: `Tabela FIPE ${brand} ${model} ${year}`,
    });

  return arr;
};

export const financiamentoBreadCrumbs = ({
  type,
  brand,
  model,
  modelSlug,
  brandSlug,
}: {
  type?: FipeVehicleType | FipeVehicleTypeUrl;
  brand?: string;
  model?: string;
  brandSlug?: string;
  modelSlug?: string;
}) => {
  const arr = [
    { label: 'Luna', href: ROUTES.root, name: 'Luna Seguros' },
    {
      label: 'Financiamento',
      href: ROUTES.financiamento.home,
      name: 'Financiamento',
    },
  ];

  const url: Record<FipeVehicleType | FipeVehicleTypeUrl, FipeVehicleTypeUrl> =
    {
      car: 'carros',
      motorcycle: 'motos',
      trucks: 'caminhoes',
      caminhoes: 'caminhoes',
      motos: 'motos',
      carros: 'carros',
    };

  if (type)
    arr.push({
      label: upperCaseFirstLetter(url[type]),
      href: ROUTES.financiamento.type({
        type,
      }),
      name: `Financiamento para ${url[type].toUpperCase()}`,
    });

  if (type && brandSlug && brand)
    arr.push({
      label: `${upperCaseFirstLetter(url[type])} ${brand}`,
      href: ROUTES.financiamento.brand({
        type,
        brand: brandSlug,
      }),
      name: `Financiamento ${url[type]} ${brand}`,
    });

  if (type && brand && model && modelSlug && brandSlug)
    arr.push({
      label: model,
      href: ROUTES.financiamento.model({
        type,
        brand: brandSlug,
        model: modelSlug,
      }),
      name: `Financiamento ${brand} ${model}`,
    });

  return arr;
};
